(() => {
  'use strict';
  if (window.FTLAudienceEvents) return;
  const el = document.getElementById('ftl-audience-config');
  if (!el) return;
  let config;
  try { config = JSON.parse(el.textContent); } catch (_) { return; }
  const preview = !config.live || !!window.Shopify?.designMode;
  const key = preview ? 'ftl_audiences_preview_v1' : 'ftl_audiences_v1';
  const timeout = 30 * 60 * 1000;
  let state = null, elapsed = 0, lastTick = performance.now(), counted = false, lastSavedActivity = 0;
  const events = {
    Viewed2Products: ['ftl_viewed_2_products', true],
    EngagedProductView: ['ftl_engaged_product_view', true],
    IntentionalAddToCart: ['ftl_intentional_add_to_cart', true],
    CtaClick: ['ftl_cta_click', false],
    VariantSelect: ['ftl_variant_select', false],
    AccessorySelect: ['ftl_accessory_select', false],
    AccessoryExpand: ['ftl_accessory_expand', false],
    MediaSelect: ['ftl_media_select', false],
    DetailExpand: ['ftl_detail_expand', false],
    SectionView: ['ftl_section_view', false],
    ScrollDepth: ['ftl_scroll_depth', false],
    VideoStart: ['ftl_video_start', false],
    VideoProgress: ['ftl_video_progress', false],
    CheckoutClick: ['ftl_checkout_click', false],
    SearchSubmit: ['ftl_search_submit', false],
    AddToCartError: ['ftl_add_to_cart_error', false]
  };
  const diagnostics = {version: '2.0.0', mode: preview ? 'preview-no-send' : 'live', consent: false, metaReady: false, gaReady: false, events: [], excludedGifts: 0};
  let output;
  if (preview) {
    output = document.createElement('script');
    output.type = 'application/json';
    output.id = 'ftl-audience-diagnostics';
    document.body.appendChild(output);
  }
  const report = () => { if (output) output.textContent = JSON.stringify({...diagnostics, distinctProducts: state?.products.length || 0, pending: state?.pending.length || 0}); };
  const allowed = () => {
    try {
      const p = window.Shopify?.customerPrivacy;
      diagnostics.privacy = p ? {analytics: p.analyticsProcessingAllowed(), marketing: p.marketingAllowed(), saleOfData: p.saleOfDataAllowed()} : {api: 'not-ready'};
      return !!(p && diagnostics.privacy.analytics && diagnostics.privacy.marketing && diagnostics.privacy.saleOfData);
    } catch (_) { diagnostics.privacy = {api: 'unavailable'}; return false; }
  };
  const save = () => { try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (_) {} };
  const reset = () => {
    state = {last: Date.now(), products: [], engaged: [], viewed2: false, pending: []};
    counted = false;
    elapsed = 0;
  };
  const readState = () => {
    if (!state) {
      try {
        const value = JSON.parse(sessionStorage.getItem(key));
        if (value && Array.isArray(value.products) && Array.isArray(value.engaged) && Array.isArray(value.pending) && Number.isFinite(value.last)) state = value;
      } catch (_) {}
    }
    if (!state || Date.now() - state.last >= timeout || state.last > Date.now()) reset();
    return state;
  };
  const clear = () => {
    state = null;
    elapsed = 0;
    counted = false;
    try { sessionStorage.removeItem(key); } catch (_) {}
  };
  const metaReady = () => {
    try { return typeof window.fbq === 'function' && !!window.fbq.getState?.().pixels?.some(p => String(p.id) === config.pixelId); }
    catch (_) { return false; }
  };
  const flush = () => {
    diagnostics.metaReady = metaReady();
    diagnostics.gaReady = !!config.gaId && typeof window.gtag === 'function';
    if (!allowed() || !state) return report();
    state.pending = state.pending.filter(event => events[event.name] && Date.now() - event.time < timeout);
    for (const event of state.pending) {
      const [gaName, meta] = events[event.name];
      if (!meta) event.metaDone = true;
      if (!event.metaDone && (preview || diagnostics.metaReady)) {
        try {
          if (!preview) window.fbq('trackSingleCustom', config.pixelId, event.name, event.data, {eventID: event.id});
          event.metaDone = true;
        } catch (_) {}
      }
      if (!event.gaDone && (preview || diagnostics.gaReady)) {
        try {
          const data = Object.fromEntries(Object.entries(event.data).map(([k, v]) => [k, Array.isArray(v) ? v.join(',').slice(0, 100) : v]));
          if (!preview) window.gtag('event', gaName, {...data, send_to: config.gaId, event_id: event.id});
          event.gaDone = true;
        } catch (_) {}
      }
      let log = diagnostics.events.find(e => e.id === event.id);
      if (!log) {
        log = {id: event.id, name: event.name, gaName, product_ids: event.data.product_ids};
        diagnostics.events.push(log);
      }
      Object.assign(log, {status: preview ? 'preview-only' : 'dispatch-status', meta: meta ? (preview ? 'preview-only' : event.metaDone ? 'submitted-to-pixel' : 'waiting-for-pixel') : 'not-targeted', ga4: preview ? 'preview-only' : event.gaDone ? 'submitted-to-tag' : 'waiting-for-tag'});
    }
    diagnostics.events = diagnostics.events.slice(-50);
    state.pending = state.pending.filter(event => !event.metaDone || !event.gaDone);
    save();
    report();
  };
  const enqueue = (name, data) => {
    if (!events[name] || !allowed()) return;
    readState();
    const id = 'ftl_' + (window.crypto?.randomUUID?.() || Date.now() + '_' + Math.random().toString(36).slice(2));
    state.pending.push({name, data: {...data, page_type: config.pageType || 'unknown', language: config.language || 'unknown', schema_version: '2', source: 'ftl_storefront'}, id, time: Date.now()});
    state.pending = state.pending.slice(-100);
    save();
    flush();
  };
  const view = () => {
    if (!config.productId || counted || document.visibilityState !== 'visible') return;
    counted = true;
    const id = String(config.productId);
    if (!state.products.includes(id)) state.products.push(id);
    state.products = state.products.slice(-100);
    if (state.products.length >= 2 && !state.viewed2) {
      state.viewed2 = true;
      enqueue('Viewed2Products', {product_ids: state.products.slice(0, 2), distinct_product_count: 2, session_timeout_minutes: 30});
    }
    save();
  };
  const tick = () => {
    const now = performance.now();
    const delta = Math.max(0, Math.min(now - lastTick, 2000));
    lastTick = now;
    diagnostics.consent = allowed();
    if (!diagnostics.consent) { clear(); return report(); }
    readState();
    view();
    if (config.productId && document.visibilityState === 'visible') {
      elapsed += delta;
      const id = String(config.productId);
      if (elapsed >= 20000 && !state.engaged.includes(id)) {
        state.engaged.push(id);
        state.engaged = state.engaged.slice(-100);
        enqueue('EngagedProductView', {product_ids: [id], visible_seconds: 20});
      }
    }
    flush();
  };
  const activity = () => {
    if (!allowed()) return;
    readState();
    state.last = Date.now();
    if (state.last - lastSavedActivity >= 5000) { save(); lastSavedActivity = state.last; }
  };
  ['pointerdown', 'keydown', 'scroll'].forEach(name => document.addEventListener(name, activity, {passive: true}));
  document.addEventListener('visibilitychange', () => { lastTick = performance.now(); tick(); });
  document.addEventListener('visitorConsentCollected', () => { lastTick = performance.now(); tick(); });
  const propertiesGift = props => props && Object.keys(props).some(k => /^_ftl_.*gift/i.test(k) && props[k]);
  const parseBody = body => {
    if (body instanceof FormData || body instanceof URLSearchParams) {
      const properties = {};
      for (const [k, v] of body.entries()) { const match = k.match(/^properties\[(.+)\]$/); if (match) properties[match[1]] = v; }
      return {id: body.get('id'), quantity: Number(body.get('quantity') || 1), properties};
    }
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (_) { return parseBody(new URLSearchParams(body)); }
    }
    return null;
  };
  const recordAddition = (result, input) => {
    if (!allowed() || !input) return;
    const requested = Array.isArray(input.items) ? input.items : [input];
    const lines = Array.isArray(result.items) ? result.items : [result];
    const paid = [];
    for (const line of lines) {
      const req = requested.find(i => String(i.id) === String(line.variant_id || line.id));
      if (!req) continue;
      if (propertiesGift(line.properties) || propertiesGift(req.properties) || Number(line.final_price ?? line.price) <= 0) { diagnostics.excludedGifts++; continue; }
      const quantity = Number(req.quantity || 1);
      if (!line.product_id || !Number.isInteger(quantity) || quantity <= 0) continue;
      paid.push({product_id: String(line.product_id), variant_id: String(line.variant_id || line.id), quantity});
    }
    if (paid.length) {
      activity();
      enqueue('IntentionalAddToCart', {product_ids: [...new Set(paid.map(i => i.product_id))], variant_ids: paid.map(i => i.variant_id), num_items: paid.reduce((sum, i) => sum + i.quantity, 0), gift_excluded: true});
    }
    report();
  };
  const originalFetch = window.fetch;
  const recordError = (input, status) => {
    if (!allowed() || !input) return;
    const requested = Array.isArray(input.items) ? input.items : [input];
    if (requested.some(item => item.id && !propertiesGift(item.properties))) enqueue('AddToCartError', {error_type: status === 0 ? 'network' : 'http', http_status: status});
  };
  if (originalFetch) window.fetch = function(input, init) {
    let observe = false, body;
    try {
      const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
      const method = String(init?.method || input?.method || 'GET').toUpperCase();
      observe = allowed() && method === 'POST' && url.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
      if (observe) body = init?.body !== undefined ? Promise.resolve(parseBody(init.body)) : input?.clone ? input.clone().text().then(parseBody) : Promise.resolve(null);
    } catch (_) { observe = false; }
    const promise = originalFetch.apply(this, arguments);
    if (observe) promise.then(response => {
      if (!response.ok) { body.then(request => recordError(request, Number(response.status) || 0)).catch(() => {}); return; }
      Promise.all([response.clone().json(), body]).then(([result, request]) => recordAddition(result, request)).catch(() => {});
    }).catch(() => { body.then(request => recordError(request, 0)).catch(() => {}); });
    return promise;
  };
  window.FTLAudienceEvents = {version: '2.0.0', allowed, track: enqueue, productId: config.productId, status: () => ({...diagnostics, events: diagnostics.events.slice()})};
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => { lastTick = performance.now(); tick(); });
  }
  activity();
  tick();
  setInterval(tick, 1000);
})();
